/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favaccessmgmt.vue?vue&type=template&id=2fcc8a88&scoped=true&"
import script from "./favaccessmgmt.vue?vue&type=script&lang=js&"
export * from "./favaccessmgmt.vue?vue&type=script&lang=js&"
import style0 from "./favaccessmgmt.vue?vue&type=style&index=0&id=2fcc8a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc8a88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VCard,VCardText,VHover,VIcon,VProgressCircular})
